<template>
  <div class="star">
    <div class="star-content">
      <div class="star-right">
        <!-- <div class="left-btn">
          <img src="../../../assets/flipLeft.png" alt="" />
        </div> -->
        <div v-show="activeType == 1 || activeType == 2">
          <div class="star-li" v-for="item in sleepData" :key="item.id">
            <div class="star-bed">{{ item.bedName }}</div>
            <div class="star-h">
              活力值：{{ item.vitality }}
              <img
                v-if="item.vitalityContrast == -1"
                src="../../../assets/icon_GoDown.png"
                alt=""
              />
              <img
                v-if="item.vitalityContrast == 1"
                src="../../../assets/icon_GoUp.png"
                alt=""
              />
              <img
                v-if="item.vitalityContrast == 0"
                src="../../../assets/icon_keep.png"
                alt=""
              />
            </div>
            <div class="star-q">
              情绪值：{{ item.morale }}
              <img
                v-if="item.moraleContrast == -1"
                src="../../../assets/icon_GoDown.png"
                alt=""
              />
              <img
                v-if="item.moraleContrast == 1"
                src="../../../assets/icon_GoUp.png"
                alt=""
              />
              <img
                v-if="item.moraleContrast == 0"
                src="../../../assets/icon_keep.png"
                alt=""
              />
            </div>
            <div class="star-d">
              跌倒风险指数：{{ item.fall }}
              <img
                v-if="item.fallContrast == -1"
                src="../../../assets/icon_GoDown.png"
                alt=""
              />
              <img
                v-if="item.fallContrast == 1"
                src="../../../assets/icon_GoUp.png"
                alt=""
              />
              <img
                v-if="item.fallContrast == 0"
                src="../../../assets/icon_keep.png"
                alt=""
              />
            </div>
            <div class="star-d">
              睡眠时长：{{ $formaTime(item.sleepDuration) }}
            </div>
            <div class="star-d">睡眠呼吸：{{ item.comment || "--" }}</div>
            <div class="star-check" @click="details(item.bedId, item.bedName)">
              查看完整报告
            </div>
            <div class="star-score">
              <div class="score">{{ item.score }}</div>
              <div class="score-title">睡眠得分</div>
            </div>
          </div>
        </div>

        <div v-show="activeType == 3 || activeType == 4">
          <div
            class="star-li star-lis"
            v-for="(item, index) in sleepData"
            :key="item.bedId + '1'"
          >
            <div class="star-bed">{{ item.bedName }}</div>
            <div class="star-h">
              睡眠总时长：{{ $formaTime(item.sumSleep) }}
            </div>
            <div class="star-sleep">睡眠平均时长：{{ $formaTime(item.avgSleep) }}</div>
            <div
              class="sleep-chart"
              :id="'sleepChart' + (index + 1)"
              :key="'sleepChart' + (index + 1)"
              style="height: 80px; margin: 0px auto"
            ></div>
            <div class="star-check" @click="details(item.bedId, item.bedName)">查看完整报告</div>
            <div class="star-score">
              <div class="score">{{ item.avgScore }}</div>
              <div class="score-title">睡眠得分</div>
            </div>
          </div>
        </div>

        <a-empty v-if="sleepData.length==0" />

        <!-- <div class="right-btn">
          <img src="../../../assets/flipRight.png" alt="" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      starData: [],
      starEmpty: false,
      sleepChart1: null,
      sleepChart2: null,
      sleepChart3: null,
      sleepChart4: null,
      sleepChart5: null,
      activeType: 1,
      sleepData: [],
      sleepEmpty:false
    };
  },
  created() {},
  mounted() {
    //this.getData(3,5);
  },
  methods: {
    details(bedId, bedName) {
      var scope = {
        bedId: bedId,
        bedName: bedName,
        activeType: this.activeType,
      };
      this.$parent.$parent.details(scope);
    },
    getData(activeType, param) {
      this.activeType = activeType;
      console.log("####", activeType);
      var that = this;
      //that.$parent.$parent.changeTotal(0);
      this.$get(
        "/api/health/getHealthPageV1",
        param,
        (res) => {
          if (res.code == 0) {
            if (res.data.records) {
              this.sleepData = res.data.records;
              that.$parent.$parent.changeTotal(res.data.total, 5);
              if (activeType == 3 || activeType == 4) {
                that.checkDetails();
              }
            } else {
              this.sleepData = [];

              that.$parent.$parent.changeTotal(0, 5);
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
      ///api/health/getHealthPageV1?pageNum=1&pageSize=20&type=1&buildingId=&floorId=&roomId=
    },
    checkDetails() {
      setTimeout(() => {
        for (let i = 1; i < 6; i++) {
          this["sleepChart" + i] = this.$echarts.init(
            document.getElementById("sleepChart" + i)
          );
          let scores = this.sleepData[i - 1].bedHealthDailyStatistics;
          console.log("##", scores);
          let dateX = [];
          let scoreY = [];
          for (var key in scores) {
            var item = scores[key];
            dateX.push(key)
            if(item==0){
              item = "";
            }
            scoreY.push(item);
            
          }

          var optionScore = {
            color: ["#1890FF"],
            tooltip: {
              trigger: "axis",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              borderColor: "rgba(24, 144, 255, 0.8)",
              // borderWidth: 1,
              borderRadius: 5,
              //   formatter: function (params) {
              //     console.log(params[0].data);
              //     return params[0].data;
              //   },
            },
            grid: {
              left: "0%",
              right: "10%",
              top: "10%",
              bottom: "0%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                axisLabel: {
                  textStyle: {
                    color: "rgba(0,0,0,0.35)", //坐标的字体颜色
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "rgba(0,0,0,0.15)",
                  },
                },
                data: dateX,
              },
            ],

            yAxis: [
              {
                type: "value",
                min: 0,
                max: 100,
                logBase: 10,
                interval: 100,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  formatter: "{value}",
                  textStyle: {
                    color: "rgba(0,0,0,0.35)", //坐标的字体颜色
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "rgba(0,0,0,0.15)",
                  },
                  show: true,
                },
              },
            ],
            series: [
              {
                data: scoreY,
                type: "line",
                smooth: true,
                symbol: "circle",
                symbolSize: 8,
                color: "#1890FF",
                markLine: {
                  symbol: "none",
                  emphasis: {
                    lineStyle: {
                      width: 1, // hover时的折线宽度
                    },
                  },
                  data: [
                    {
                      silent: false, //鼠标悬停事件  true没有，false有
                      lineStyle: {
                        //警戒线的样式  ，虚实  颜色
                        type: "dashed",
                        color: "#C394FE",
                      },
                      label: {
                        position: "end",
                        formatter: "",
                      },
                      yAxis: 60, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                    },
                  ],
                },
              },
            ],
          };

          this["sleepChart" + i].clear();
          this["sleepChart" + i].setOption(optionScore);
          window.addEventListener("resize", () => {
            this["sleepChart" + i].resize();
          });
        }
      }, 500);
    },
    //bedHealthDailyStatistics
  },
};
</script>
<style lang="scss" scoped>
.star {
  width: 100%;
  height: 282px;
  margin-top: 30px;
  // display: flex;
  // flex-direction: row;
  // align-items: center;
  // justify-content: flex-start;

  .star-top {
    width: 100%;
    height: 30px;
    .star-last {
      color: #8c8c8c;
      line-height: 12px;
      font-size: 10px;
      float: left;
      margin: 10px 0 0 10px;
    }
    .star-more {
      float: right;
      color: #1890ff;
      line-height: 18px;
      font-size: 12px;
      margin: 10px 10px 0 10px;
      cursor: pointer;
    }
  }
  .star-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    .star-left {
      width: 250px;
      height: 200px;
      display: inline-block;
      position: relative;
      img {
        width: 107px;
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1;
      }
      .star-desc {
        display: inline-block;
        width: 170px;
        margin: 60px 0 0 50px;
        z-index: 10;
        position: relative;
        color: #262626;
        line-height: 24px;
        font-size: 16px;
      }
    }
    .star-right {
      width: 1200px;
      height: 240px;
      display: inline-block;
      margin-left: 0px;
      position: relative;
      .left-btn {
        position: absolute;
        top: 70px;
        left: -18px;
        z-index: 10;
        width: 55px;
        height: 55px;
        display: inline-block;
        img {
          width: 0px;
        }
      }
      .left-btn:hover {
        img {
          width: 55px;
          cursor: pointer;
        }
      }

      .right-btn {
        position: absolute;
        top: 70px;
        right: -7px;
        z-index: 10;
        width: 55px;
        height: 55px;
        display: inline-block;
        img {
          width: 0px;
        }
      }
      .right-btn:hover {
        img {
          width: 55px;
          cursor: pointer;
        }
      }

      .star-li {
        width: 215px;
        height: 245px;
        background: #ffffff;
        box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        margin-top: 10px;
        position: relative;
        display: inline-block;
        margin-left: 10px;
        .sleep-chart {
          width: 100%;
        }
        .star-score {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 62px;
          height: 62px;
          border-radius: 31px;
          border: 3px solid #1890ff;
          text-align: center;
          .score {
            font-size: 22px;
            color: #262626;
            line-height: 24px;
            margin-top: 4px;
          }
          .score-title {
            font-size: 10px;
            color: #8c8c8c;
            line-height: 12px;
          }
        }
        .star-bed {
          overflow: hidden;
          text-overflow: ellipsis; //显示省略号
          display: -webkit-box;
          -webkit-line-clamp: 2; //块元素显示的文本行数
          -webkit-box-orient: vertical;
          // white-space: nowrap;
          width: 120px;
          margin-left: 10px;
          margin-top: 20px;
          color: #262626;
          line-height: 18px;
          font-size: 14px;
          height: 40px;
        }
        .star-h {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 20px;
        }
        .star-q {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 20px;
        }
        .star-d {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 10px;
        }
        .star-sleep {
          color: #262626;
          line-height: 20px;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-top: 0px;
        }
        .star-h,
        .star-q,
        .star-d {
          img {
            width: 12px;
            position: relative;
            top: -2px;
            margin-left: 3px;
          }
        }
        .star-check {
          width: 190px;
          height: 32px;
          background: #1890ff;
          border-radius: 2px;
          color: white;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          margin-left: 10px;
          margin-top: 10px;
          cursor: pointer;
        }
      }

      .star-lis {
        height: 258px;
      }
    }
  }
}
</style>